export default __webpack_public_path__ + "static/media/Kuthcheman Longbow.bd37c27c.jpg";